(() => {
  const DURATION = 260;
  const EASING = 'ease';

  const prefersReduced =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const drawer = document.querySelector('#menu-drawer');
  if (!drawer) return;

  const detailsList = drawer.querySelectorAll('details.menu-drawer__menu-item-details');

  function getContent(details) {
    // submenu = first UL directly under details (your structure)
    return details.querySelector(':scope > ul');
  }

  function animateOpen(details) {
    const content = getContent(details);
    if (!content) return;

    // If reduced motion, just open
    if (prefersReduced) {
      details.open = true;
      content.style.height = '';
      return;
    }

    // Open first so scrollHeight is measurable
    details.open = true;

    // Start from 0
    content.style.height = '0px';

    // Force layout so the browser acknowledges height=0 before animating
    content.getBoundingClientRect();

    const target = content.scrollHeight;

    const anim = content.animate(
      [{ height: '0px' }, { height: `${target}px` }],
      { duration: DURATION, easing: EASING }
    );

    anim.onfinish = () => {
      // Let it size naturally after animation
      content.style.height = '';
    };
  }

  function animateClose(details) {
    const content = getContent(details);
    if (!content) return;

    if (prefersReduced) {
      details.open = false;
      content.style.height = '';
      return;
    }

    // Measure while still open
    const start = content.scrollHeight;

    // Lock current height so it can animate down
    content.style.height = `${start}px`;
    content.getBoundingClientRect();

    const anim = content.animate(
      [{ height: `${start}px` }, { height: '0px' }],
      { duration: DURATION, easing: EASING }
    );

    anim.onfinish = () => {
      details.open = false;     // now actually close (content will disappear)
      content.style.height = ''; // cleanup
    };
  }

  // Override native toggle so we can animate both directions
  detailsList.forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    const content = getContent(details);
    if (!summary || !content) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault(); // stop native instant toggle

      if (details.open) {
        animateClose(details);
      } else {
        animateOpen(details);
      }
    });
  });
})();
